export default {
  data() {
    return {
      lng: lng,
      user: myApp.user
    };
  },

  beforeCreate() {
    console.log('beforeCreate');
  },

  created() {
    console.log('created');
  },

  beforeMount() {
    console.log('beforeMount');
  },

  mounted() {
    console.log('mounted');
  },

  updated() {
    console.log('updated');
  },

  beforeDestroy() {
    console.log('beforeDestroy');
  },

  destroyed() {
    console.log('destroyed');
  },

  on: {
    pageMounted(e, page) {
      console.log('page mounted');
    },

    pageInit(e, page) {
      console.log('page init');
      console.log(e, page);
    },

    pageBeforeIn(e, page) {
      console.log('page before in');
    },

    pageAfterIn(e, page) {
      console.log('page after in');
    },

    pageBeforeOut(e, page) {
      console.log('page before out');
    },

    pageAfterOut(e, page) {
      console.log('page after out');
    },

    pageBeforeUnmount(e, page) {
      console.log('page before unmount');
    },

    pageBeforeRemove(e, page) {
      console.log('page before remove');
    }

  },
  methods: {},
  id: '4b423bec53',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="title">';
      r += c(ctx_1.lng.poiLegalInformations, ctx_1);
      r += '</div>\n        <div class="right">\n          <a href="/">\n            <i class="icon f7-icons">house</i>\n          </a>\n        </div>\n      </div>\n    </div>\n    <div class="page-content">\n      <div class="block-title">\n        ';
      r += c(ctx_1.lng.clientCode, ctx_1);
      r += '\n      </div>\n      <div class="list simple-list">\n        <ul>\n          <li>';
      r += c(ctx_1.user.client_code, ctx_1);
      r += '</li>\n        </ul>\n        <div class="block-title">\n          ';
      r += c(ctx_1.lng.documents, ctx_1);
      r += '\n        </div>\n        <div class="list simple-list">\n          <ul>\n            <li>\n              <a class="external" target="_system" href="https://infomycity.com/documents/';
      r += c(ctx_1.lng.language, ctx_1);
      r += '/terms-and-conditions.html">';
      r += c(ctx_1.lng.termsAndConditions, ctx_1);
      r += '</a>\n            </li>\n            <li>\n              <a class="external" target="_system" href="https://infomycity.com/documents/';
      r += c(ctx_1.lng.language, ctx_1);
      r += '/privacy-policy.html">';
      r += c(ctx_1.lng.privacyPolicy, ctx_1);
      r += '</a>\n            </li>\n            <li>\n              <a class="external" target="_system" href="https://infomycity.com/documents/';
      r += c(ctx_1.lng.language, ctx_1);
      r += '/cookies.html">';
      r += c(ctx_1.lng.cookiesPolicy, ctx_1);
      r += '</a>\n            </li>\n            <li>\n              <a class="external" target="_system" href="https://infomycity.com/documents/';
      r += c(ctx_1.lng.language, ctx_1);
      r += '/termsAndAgreementClient.pdf">';
      r += c(ctx_1.lng.termsAndAgreement, ctx_1);
      r += '</a>\n            </li>\n          </ul>\n        </div>\n        <div class="block">\n          <img style="display: block; margin: auto; width: 350px; max-width: 100%" src="static/Infomycity.jpg" alt=""/>\n          <p><strong>Infomycity Societè par Actions</strong> <br>\n            4 Rue Des Freres Piccò c / o CB Service <br>\n            06500 Menton France <br> \n            FR13752020792 <br> \n            Website: <a href="https://infomycity.net" class="external text-color-imc" target="_system">www.infomycity.net</a>\n          </p>\n          <!-- Email: <a href="mailto:infomylove@infomycity.net" class="external" target="_system">infomylove@infomycity.net</a> -->\n          <a href="https://www.facebook.com/Infomycity-Book-Pay-Everything-You-Need-113703007218164"\n             target="_system"\n             class="external button text-color-imc">';
      r += c(ctx_1.lng.contactUs, ctx_1);
      r += '</a>\n        </div>\n        <hr>\n        <div class="block-title">\n          Credits\n        </div>\n        <div class="block">\n          <img src="static/dreamgest-logo-transparent-200.png" alt=""/> <br> \n          UI design: Federico Lovotrico <br>\n          Software & API: Dreamgest ltd <br>\n          27 Old Gloucester Street, <br>\n          London, United Kingdom, WC1N 3AX <br> \n          Website: <a href="https://dreamgest.com" class="external text-color-imc" target="_system">www.dreamgest.com</a>\n        </div>\n      </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};